module.exports = __webpack_public_path__ + "img/ed-dark.667a9bc.png";